var hostname = window.location.hostname;
var isProd = hostname === 'tvc.snell.com.tw';
// var disable = isProd ? false : true;
window.__bl = {
    config: {
        pid: "egrrccpv71@e617af567f21bb5",
        appType: "web",
        imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        sendResource: true,
        enableLinkTrace: true,
        behavior: true,
        disabled: false,
        environment: isProd ? 'prod' : 'local',
        page: window.pageName,
    }
}